module.exports = "pegasus/assets/preview-11.png";